import type { PropsOf } from "@builder.io/qwik";
import { component$, Slot } from "@builder.io/qwik";
import { Label as LabelPrimitive } from "@qwik-ui/headless";
import { cn } from "~/lib/cn";
import { cva, type VariantProps } from "class-variance-authority";

const labelVariants = cva(
  "font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      size: {
        sm: "text-sm",
        lg: "text-lg",
        md: "text-md",
        xl: "text-xl",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  },
);
type LabelProps = PropsOf<"label"> & VariantProps<typeof labelVariants>;

export const Label = component$<LabelProps>(({ size, ...props }) => (
  <LabelPrimitive {...props} class={cn(labelVariants({ size }), props.class)}>
    <Slot />
  </LabelPrimitive>
));
